import * as actionTypes from "./actionTypes";

export const getBestSale = () => ({
	type: actionTypes.GET_BEST_SALE_ACTION
});

export const setBestSale = params => ({
	type: actionTypes.SET_BEST_SALE_ACTION,
	params
});

export const getCRMShopInfoDetail = () => ({
	type: actionTypes.GET_CRM_SHOP_INFO_ACTION
});

export const getCRMShopInfoSplashDetail = params => ({
	type: actionTypes.GET_CRM_SHOP_INFO_SPLASH_ACTION,
	params
});

export const setCRMShopInfoDetail = params => ({
	type: actionTypes.SET_CRM_SHOP_INFO_ACTION,
	params
});

export const getCRMLevelInfo = () => ({
	type: actionTypes.GET_CRM_LEVEL_INFO_ACTION
});

export const setCRMLevelInfo = params => ({
	type: actionTypes.SET_CRM_LEVEL_INFO_ACTION,
	params
});

export const getCRMRewardDetailAction = params => ({
	type: actionTypes.GET_CRM_REWARD_DETAIL_ACTION,
	params
});

export const setCRMRewardDetailAction = params => ({
	type: actionTypes.SET_CRM_REWARD_DETAIL_ACTION,
	params
});

export const signatureRewardConfirmAction = params => ({
	type: actionTypes.SIGNATURE_REWARD_CONFIRM_ACTION,
	params
});
